import { render, staticRenderFns } from "./modify-password-modal.vue?vue&type=template&id=25cfc8ea&"
import script from "./modify-password-modal.vue?vue&type=script&lang=js&"
export * from "./modify-password-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports